module.exports = __webpack_public_path__ + "static/media/Xtra_Large_6.19466c45.jpg";